module.exports = __webpack_public_path__ + "static/media/modelo-adicionar-membros-campanha.261c7d63.csv";